export default __webpack_public_path__ + "static/transport1-img-54bd742b6cb1b7756e3dc1b4ad7af3bf.jpg";